import React, { useState, useEffect } from 'react';
import AdminLayout from '../layouts/AdminLayout';
import adminApi from '../api/adminApi';
import { FaUserMd, FaConciergeBell, FaPen, FaCalendarCheck } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const DashboardPage = () => {
  const [stats, setStats] = useState({ doctors: 0, services: 0, blogs: 0, appointments: 0 });
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [docRes, svcRes, blogRes, apptRes] = await Promise.all([
          adminApi.get('/doctors/all'),
          adminApi.get('/services/all'),
          adminApi.get('/blog/all'),
          adminApi.get('/appointments'),
        ]);
        setStats({
          doctors: docRes.data.length,
          services: svcRes.data.length,
          blogs: blogRes.data.length,
          appointments: apptRes.data.length,
        });
        setAppointments(apptRes.data.slice(0, 5));
      } catch (e) {
        console.error(e);
      } finally { setLoading(false); }
    };
    fetchAll();
  }, []);

  const STAT_CARDS = [
    { label: 'Total Doctors', value: stats.doctors, icon: <FaUserMd />, color: 'teal', link: '/admin/doctors' },
    { label: 'Services', value: stats.services, icon: <FaConciergeBell />, color: 'navy', link: '/admin/services' },
    { label: 'Blog Posts', value: stats.blogs, icon: <FaPen />, color: 'gold', link: '/admin/blog' },
    { label: 'Appointments', value: stats.appointments, icon: <FaCalendarCheck />, color: 'green', link: '/admin/appointments' },
  ];

  const statusBadge = s => {
    const map = { Pending: 'pending', Confirmed: 'confirmed', Cancelled: 'cancelled', Completed: 'completed' };
    return <span className={`admin-badge ${map[s] || 'pending'}`}>● {s || 'Pending'}</span>;
  };

  return (
    <AdminLayout title="Dashboard" subtitle="Welcome back — here's what's happening today">
      {/* Stat Cards */}
      <div className="admin-stats-grid" id="dashboard-stats">
        {STAT_CARDS.map(card => (
          <Link to={card.link} key={card.label} style={{ textDecoration: 'none' }}>
            <div className="admin-stat-card" id={`stat-${card.label.toLowerCase().replace(/\s+/g, '-')}`}>
              <div className={`admin-stat-icon ${card.color}`}>{card.icon}</div>
              <div>
                <div className="admin-stat-value">{loading ? '…' : card.value}</div>
                <div className="admin-stat-label">{card.label}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Recent Appointments */}
      <div className="admin-card" id="dashboard-recent-appointments">
        <div className="admin-card-header">
          <div className="admin-card-title">Recent Appointments</div>
          <Link to="/admin/appointments" className="admin-btn admin-btn-ghost admin-btn-sm">View All →</Link>
        </div>
        <div className="admin-table-wrapper">
          <table className="admin-table" id="dashboard-appt-table">
            <thead>
              <tr>
                <th>Patient</th><th>Doctor</th><th>Date</th><th>Reason</th><th>Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={5} style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>Loading…</td></tr>
              ) : appointments.length === 0 ? (
                <tr><td colSpan={5} style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>No appointments yet.</td></tr>
              ) : appointments.map(a => (
                <tr key={a.id} id={`dashboard-appt-${a.id}`}>
                  <td>
                    <div style={{ fontWeight: 600 }}>{a.patientName}</div>
                    <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{a.email}</div>
                  </td>
                  <td>
                    <div>{a.doctorName}</div>
                    <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{a.doctorSpecialty}</div>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {new Date(a.appointmentDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </td>
                  <td style={{ maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.reason}</td>
                  <td>{statusBadge(a.status)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
};

export default DashboardPage;
